import IdentifyLetter from "../../components/UKG/Mathematics/OrdinalLetters";
import IdentifyPosition from "../../components/UKG/Mathematics/OrdinalNumbersPosition";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - UKG - Mathematics - Ordinal Numbers";

const topics: MenuItem[] = [
    { url: "/ukg/mathematics/ordinal-numbers/object-from-position", title: "Find Object from Position", component: IdentifyPosition},
    { url: "/ukg/mathematics/ordinal-numbers/solve-riddle", title: "Solve Riddle", component: IdentifyLetter},
];


export default topics;